import React from "react";
import { connect } from "react-redux";
import { CardItem } from "../../../../../components/card/Card";
import Button from "../../../../../components/ripple/Button";
import styles from './DockerComposePreview.module.scss'
import { dispatchNotification } from "../../../../../layouts/app/components/notificationSystem/notifications";

function DockerComposePreview({composeData}) {
    return (
            <div className={styles.layout}>
                <CardItem className={styles.content}>
                    <pre className={styles.content__pre} id='docker-compose-content'>
                        {composeData}
                        <Button
                            className={styles.content__pre__copy}
                            icon='far fa-copy'
                            displayType='text'
                            onClick={() => {
                                const range = document.createRange();
                                range.selectNode(document.getElementById('docker-compose-content'));
                                window.getSelection().removeAllRanges();
                                window.getSelection().addRange(range);
                                document.execCommand("copy");
                                window.getSelection().removeAllRanges();
                                dispatchNotification({
                                    message: 'Copied to clipboard',
                                    type: 'success',
                                })
                            }}
                        />
                    </pre>
                </CardItem>
            </div>
    )
}

const mapStateToProps = state => ({
    requestLoading: state.deployment.requestLoading,
});

export default connect(mapStateToProps)(DockerComposePreview)